export const getItem = (key) => {
  if (sessionStorage.getItem(key)) {
    return JSON.parse(sessionStorage.getItem(key));
  }
  return null;
};
export const setItem = (key, value) => {
  console.log('setItem', key);
  sessionStorage.setItem(key, JSON.stringify(value));
};

export const removeItem = (key) => {
  sessionStorage.removeItem(key);
};



// WEBPACK FOOTER //
// ./src/util/SessionStorageService.js